const boatRentals: BoatRental[] = [
  {
    id: 'cabo-san-lucas-mexico',
    imgSrc: 'images/rentals/cabo-san-lucas-mexico-2.jpg',
    pageTitle: 'Cabo San Lucas Boat Charters & Rentals',
    h1: 'Rent a Boat in Cabo San Lucas, Mexico',
    queryParams: {
      latitudeSw: 22.8719539215,
      longitudeSw: -110.0216080368,
      latitudeNe: 22.9954640624,
      longitudeNe: -109.7564143058,
      near: 'Cabo San Lucas, BCS, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Cabo San Lucas',
    faq: [
      {
        question: 'What are the best destinations during your Cabo San Lucas boat charter?',
        answer:
          "You'll fall in love with the stunning Arch of Cabo San Lucas framing a perfect ocean vista—it's a photographer's dream. Venture to Lover's Beach for sun-kissed sands and gentle surf, then glide over to the Sea of Cortez, where playful pods of whales often appear. If you're in the mood for snorkeling, clear waters at Santa María Bay and Chileno Bay are ideal for spotting vibrant marine life.",
      },
      {
        question: 'Where can you dock your yacht charter in Cabo San Lucas?',
        answer:
          "Marina Cabo San Lucas is the place to be—it offers top-tier slip service and syncs effortlessly with the town's buzzing nightlife. Dock here and step ashore to discover elegant restaurants, upscale shops, and vibrant entertainment just moments away. The marina's professionalism and friendly staff ensure a hassle-free, welcoming experience.",
      },
      {
        question: 'What is the best season to sail in Cabo San Lucas?',
        answer:
          "For calm seas, pleasant temperatures, and amazing wildlife encounters, sail between November and May. This period also marks prime whale-watching season, with majestic humpbacks passing through. Whether you're navigating serene waters or enjoying golden sunsets, this season promises unforgettable sailing moments.",
      },
    ],
  },
  {
    id: 'san-jose-del-cabo-mexico',
    imgSrc: 'images/rentals/san-jose-del-cabo-mexico-2.jpg',
    pageTitle: 'San Jose del Cabo Boat Charters & Rentals',
    h1: 'Rent a Boat in San Jose del Cabo, Mexico',
    queryParams: {
      latitudeSw: 22.8302243449,
      longitudeSw: -109.9145230594,
      latitudeNe: 23.3548348205,
      longitudeNe: -109.4719728599,
      near: 'San José del Cabo, BCS, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'San Jose del Cabo',
    faq: [
      {
        question: 'What are the best destinations during your San Jose del Cabo boat charter?',
        answer:
          'Glide along the tranquil shores of Palmilla Beach with its pristine sands and panoramic beauty. Costa Azul offers playful waves and world-class surfing views, while the rugged East Cape invites you to discover untouched coastlines and exceptional fishing.',
      },
      {
        question: 'Where can you dock your yacht charter in San Jose del Cabo?',
        answer:
          "Dock at Puerto Los Cabos Marina for a seamless blend of convenience and charm. You'll have upscale amenities at your fingertips and easy access to San Jose's famed art district and golden beaches.",
      },
      {
        question: 'What is the best season to sail in San Jose del Cabo?',
        answer:
          'November through April is your window for calm seas, sunny skies, and ideal sailing breezes. Expect blue horizons, mild warmth, and perfect conditions for everything from snorkeling to sunset cruising.',
      },
    ],
  },
  {
    id: 'puerto-vallarta-mexico',
    imgSrc: 'images/rentals/puerto-vallarta-mexico-2.jpg',
    pageTitle: 'Puerto Vallarta Boat Rentals & Charters',
    h1: 'Rent a Boat in Puerto Vallarta, Mexico',
    queryParams: {
      latitudeSw: 20.5816065325,
      longitudeSw: -105.2708690175,
      latitudeNe: 20.7001141741,
      longitudeNe: -105.1777452278,
      near: 'Puerto Vallarta, Jalisco, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Puerto Vallarta',
    faq: [
      {
        question: 'What are the best destinations during your Puerto Vallarta boat charter?',
        answer:
          "Discover the breathtaking arches and hidden beaches of Los Arcos Marine Park—an explorer's paradise. Drift into the charming village of Yelapa, accessible only by sea, and refresh with a cliffside swim.",
      },
      {
        question: 'Where can you dock your yacht charter in Puerto Vallarta?',
        answer:
          "Marina Vallarta is your go-to port—it's centrally located and buzzing with life. This full-service marina puts you steps away from trendy eateries, boutiques, and Mexican flair.",
      },
      {
        question: 'What is the best season to sail in Puerto Vallarta?',
        answer:
          "From November to May, the skies stay clear, the seas stay calm, and the adventure is endless. It's the perfect time to chart your course under sunlit skies and relish warm air temperatures.",
      },
    ],
  },
  {
    id: 'cancun-mexico',
    imgSrc: 'images/rentals/cancun-mexico-2.jpg',
    pageTitle: 'Cancun Boat Rentals & Charters',
    h1: 'Rent a Boat in Cancun, Mexico',
    queryParams: {
      latitudeSw: 21.0297632383,
      longitudeSw: -86.9722675545,
      latitudeNe: 21.2130332751,
      longitudeNe: -86.7405401406,
      near: 'Cancún, Quintana Roo, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Cancun',
    faq: [
      {
        question: 'What are the best destinations during your Cancun boat charter?',
        answer:
          'Hop over to Isla Mujeres, a pastel-colored Caribbean gem with laid-back charm and pristine beaches. Next, venture to the protected natural haven of Isla Contoy where seclusion and wildlife reign.',
      },
      {
        question: 'Where can you dock your yacht charter in Cancun?',
        answer:
          'Marina Puerto Cancun and Marina Las Perlas are your top picks, equipped with modern amenities and easy admittance to the Hotel Zone. Docking here plugs you into luxurious surroundings and vibrant beachfront dining.',
      },
      {
        question: 'What is the best season to sail in Cancun?',
        answer:
          "December through April is sailing perfection—sunny days, gentle trade winds, and sparkling blue seas. There's minimal rain, and the air feels fresh, inviting you to cruise corner to corner.",
      },
    ],
  },
  {
    id: 'playa-del-carmen-mexico',
    imgSrc: 'images/rentals/playa-del-carmen-mexico-2.jpg',
    pageTitle: 'Playa del Carmen Boat Rentals & Charters',
    h1: 'Rent a Boat in Playa del Carmen, Mexico',
    queryParams: {
      latitudeSw: 20.4441823834,
      longitudeSw: -87.2944174763,
      latitudeNe: 20.8689927982,
      longitudeNe: -86.8657249708,
      near: 'Playa del Carmen, Quintana Roo, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Playa del Carmen',
    faq: [
      {
        question: 'What are the best destinations during your Playa del Carmen boat charter?',
        answer:
          "Sail toward Cozumel Island, where world-famous reefs—like Inah Reef—beckon with underwater wonders. Explore Punta Venado's coral gardens, swim alongside turtles, or drift to secluded beaches far from the crowds.",
      },
      {
        question: 'Where can you dock your yacht charter in Playa del Carmen?',
        answer:
          'Marina Puerto Aventuras is a short, scenic ride from Playa del Carmen and offers full-service docking and welcoming shoreside amenities.',
      },
      {
        question: 'What is the best season to sail in Playa del Carmen?',
        answer:
          "The season of November through April gives you picture-perfect conditions—radiant sun, gentle winds, and calm seas. It's the prime time for snorkeling, day trips, and evening cocktails on deck.",
      },
    ],
  },
  {
    id: 'turks-and-caicos',
    imgSrc: 'images/rentals/turks-and-caicos-2.jpg',
    pageTitle: 'Turks and Caicos Boat Rentals & Charters',
    h1: 'Rent a Boat in Turks and Caicos',
    queryParams: {
      latitudeSw: 21.1459922083,
      longitudeSw: -72.5207000167,
      latitudeNe: 22.0016284663,
      longitudeNe: -71.059499934,
      near: 'Turks and Caicos Islands',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Turks and Caicos',
    faq: [
      {
        question: 'What are the best destinations during your Turks and Caicos boat charter?',
        answer:
          "Romance meets adventure in Grace Bay's powdery sands and turquoise waters—pure paradise. Sail into Half Moon Bay for its heart-shaped coastline and gentle swells.",
      },
      {
        question: 'Where can you dock your yacht charter in Turks and Caicos?',
        answer:
          'Blue Haven Marina and Turtle Cove Marina on Providenciales are your top berthing options, offering upscale facilities and easy access to chic beach clubs and boutiques.',
      },
      {
        question: 'What is the best season to sail in Turks and Caicos?',
        answer:
          "December through May offers flawless sailing—warm breezes, calm lagoons, and deeply blue skies. It's the kind of sailing that sparks joy, with every sunset more stunning than the last.",
      },
    ],
  },
  {
    id: 'saint-martin',
    imgSrc: 'images/rentals/saint-martin-2.jpg',
    pageTitle: 'Saint Martin Boat Rentals & Charters',
    h1: 'Rent a Boat in Saint Martin',
    queryParams: {
      latitudeSw: 17.8897312487,
      longitudeSw: -63.3190000657,
      latitudeNe: 18.2916000794,
      longitudeNe: -62.8053000866,
      near: 'St Martin',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Saint Martin',
    faq: [
      {
        question: 'What are the best destinations during your St Martin boat charter?',
        answer:
          'Discover the postcard perfection of Pinel Island, with its sun-drenched sands and beach bars. Sail to the unspoiled haven of Tintamarre Island, where the sea feels like liquid sapphire.',
      },
      {
        question: 'Where can you dock your yacht charter in St Martin?',
        answer:
          'Drop anchor at Marina Fort Louis in Marigot or Marina Port La Royale: two elegant marinas combining convenient berths with French-Caribbean flair.',
      },
      {
        question: 'What is the best season to sail in St Martin?',
        answer:
          'Plan your voyage between December and April—the seas are peaceful, the sky is clear, and the island buzzes with festive energy. Trade winds are at their best, making days on deck effortless.',
      },
    ],
  },
  {
    id: 'anguilla',
    imgSrc: 'images/rentals/anguilla-2.jpg',
    pageTitle: 'Anguilla Boat Charters & Rentals',
    h1: 'Rent a Boat in Anguilla',
    queryParams: {
      latitudeSw: 17.9125043383,
      longitudeSw: -63.7143000049,
      latitudeNe: 18.8672325896,
      longitudeNe: -62.6860000122,
      near: 'Anguilla',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Anguilla',
    faq: [
      {
        question: 'What are the best destinations during your Anguilla boat charter?',
        answer:
          'Skip across the water to Prickly Pear Cays, where nude sands invite full relaxation. Drift to Sandy Island and dip into low-key beach bars that feel like your own secret hideaway. Shoal Bay awaits with powdery white sand fringed by hidden coral reefs and vibrant turquoise waters.',
      },
      {
        question: 'Where can you dock your yacht charter in Anguilla?',
        answer:
          "Anchor in Road Bay for easy access to the island's charming eateries and boutiques scattered along the waterfront. This primary mooring spot offers calm waters and a laid-back island rhythm. Whether you're strolling shorelines or embracing the local scene, you feel instantly at home.",
      },
      {
        question: 'What is the best season to sail in Anguilla?',
        answer:
          "December through May is your sweet spot: warm sunshine, predictable breezes, and tranquil waters. It's the season of soft sails and unforgettable sunsets. When you're here during these months, every day feels tailor-made for paradise.",
      },
    ],
  },
  {
    id: 'saint-barthelemy',
    imgSrc: 'images/rentals/saint-barthelemy-2.jpg',
    pageTitle: 'St Barths Boat Charters & Rentals',
    h1: 'Rent a Boat in St Barths',
    queryParams: {
      latitudeSw: 17.6442647017,
      longitudeSw: -63.1082267526,
      latitudeNe: 18.1631044918,
      longitudeNe: -62.5550913128,
      near: 'Saint-Barthélemy Island, 97133, St Barthélemy',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'St. Barths',
    faq: [
      {
        question: 'What are the best destinations during your St Barths boat charter?',
        answer:
          "Slip into the secluded cove of Colombier Beach, reachable only by boat, and experience exclusive serenity. Shell Beach's white pebbles shimmer in the sunlight, perfect for sunbathing and snorkeling. For off-island flair, sail to Île Fourchue to discover raw, untouched scenery and dramatic coastal views.",
      },
      {
        question: 'Where can you dock your yacht charter in St Barths?',
        answer:
          "Gustavia Harbor offers moorings with VIP service; this iconic port places you at the heart of St Barths luxury. Step right into high-end boutiques, gourmet restaurants, and glamorous island nightlife. The harbor's professionalism and elegance make every docking feel like a grand entrance.",
      },
      {
        question: 'What is the best season to sail in St Barths?',
        answer:
          "December through April delivers peak sailing pleasure, with gentle winds and clear skies. It's also prime time for exclusive events like the St Barths Bucket regatta—adding a dash of high-energy glamour. Sail this season and feel the island's vibrant, upscale rhythm.",
      },
    ],
  },
  {
    id: 'nassau-the-bahamas',
    imgSrc: 'images/rentals/nassau-the-bahamas-2.jpg',
    pageTitle: 'Nassau Boat Rentals & Charters',
    h1: 'Rent a Boat in Nassau, The Bahamas',
    queryParams: {
      latitudeSw: 24.97890031905646,
      longitudeSw: -77.5559234156322,
      latitudeNe: 25.08622076436888,
      longitudeNe: -77.25826265109018,
      near: 'Nassau, The Bahamas',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'The Bahamas',
    faq: [
      {
        question: 'What are the best destinations during your Nassau boat charter?',
        answer:
          'Imagine drifting to Rose Island—a private-sand sanctuary surrounded by crystal-clear waters. Blue Lagoon Island offers marine encounters with dolphins and sea lions, perfect for families.',
      },
      {
        question: 'Where can you dock your yacht charter in Nassau?',
        answer:
          "Nassau Yacht Haven and Bay Street Marina are top-tier docking options, steps from city life. You'll be connected to colorful downtown, bustling markets, and island entertainment within minutes.",
      },
      {
        question: 'What is the best season to sail in Nassau?',
        answer:
          "November to April brings calm seas, clear horizons, and welcoming temperatures. It's the perfect slice of Caribbean weather—great for snorkeling, lounging, and island-hopping.",
      },
    ],
  },
  {
    id: 'grand-cayman-cayman-islands',
    imgSrc: 'images/rentals/grand-cayman-cayman-islands-2.jpg',
    pageTitle: 'Grand Cayman Boat Rentals & Charters',
    h1: 'Rent a Boat in Grand Cayman, Cayman Islands',
    queryParams: {
      latitudeSw: 19.26293706034017,
      longitudeSw: -81.42020294701692,
      latitudeNe: 19.39681718826497,
      longitudeNe: -81.08465200721439,
      near: 'Grand Cayman, Cayman Islands',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Cayman Islands',
    faq: [
      {
        question: 'What are the best destinations during your Grand Cayman boat charter?',
        answer:
          "Stingray City calls—with its friendly rays in shallow sand flats, it's a once-in-a-lifetime marine encounter. Seven Mile Beach invites you to stroll along golden sands and chill under swaying palms. Then, anchor at Cemetery Reef or Eden Rock for some of the island's best snorkeling.",
      },
      {
        question: 'Where can you dock your yacht charter in Grand Cayman?',
        answer:
          "Camana Bay Marina and George Town Harbour offer stellar berthing with full service and stylish surroundings. Located near fine dining, lively shops, and coastal amenities, both marinas ensure a high-quality stay. They're known for their professional crews and maintenance standards—time on deck begins the moment you arrive.",
      },
      {
        question: 'What is the best season to sail in Grand Cayman?',
        answer:
          "December to April sets the stage for dreamy sailing—warm weather, steady trade winds, and gentle swells. Perfect visibility for diving into bright underwater life just beyond the hull. It's your ideal season for Caribbean cruising revelation.",
      },
    ],
  },
  {
    id: 'la-romana-dominican-republic',
    imgSrc: 'images/rentals/la-romana-dominican-republic-2.jpg',
    pageTitle: 'La Romana Boat Charters & Rentals',
    h1: 'Rent a Boat in La Romana, Dominican Republic',
    queryParams: {
      latitudeSw: 18.39614875825055,
      longitudeSw: -69.05997272311772,
      latitudeNe: 18.46927037235193,
      longitudeNe: -68.88506806654838,
      near: 'La Romana, Dominican Republic',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'La Romana',
    faq: [
      {
        question: 'What are the best destinations during your La Romana boat charter?',
        answer:
          'Cruise to Catalina Island, with its crystalline waters and untouched reefs ready for snorkeling. Boca Chica offers a festive vibe and quiet coves just off the mainland. Head further to Beata Island, where dramatic cliffs and desert-like coastlines feel like stepping onto another planet.',
      },
      {
        question: 'Where can you dock your yacht charter in La Romana?',
        answer:
          "Casa de Campo Marina is your base in La Romana—it's a luxury hub with full marina services and upscale surroundings. Conveniently close to polo fields, world-class golf, and refined resorts, it gives you the taste of high-end Dominican living. The team here is known for attentive care and meticulous dockside support.",
      },
      {
        question: 'What is the best season to sail in La Romana?',
        answer:
          "December to April is prime time: bright sunshine, low humidity, and gentle seas. It's the season when the entire region sparkles under perfect weather. Sailing here during these months means carefree days and unforgettable views.",
      },
    ],
  },
  {
    id: 'punta-cana-dominican-republic',
    imgSrc: 'images/rentals/punta-cana-dominican-republic-2.jpg',
    pageTitle: 'Punta Cana Boat Rentals & Charters',
    h1: 'Rent a Boat in Punta Cana, Dominican Republic',
    queryParams: {
      latitudeSw: 18.4414207285345,
      longitudeSw: -68.62197856713118,
      latitudeNe: 18.84083609199668,
      longitudeNe: -68.3228899923726,
      near: 'Punta Cana, Dominican Republic',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Punta Cana',
    faq: [
      {
        question: 'What are the best destinations during your Punta Cana boat charter?',
        answer:
          "Steer toward Isla Saona for powder-white beaches, swaying coconut palms, and natural pools teeming with tropical fish. Enjoy a coastal drift along Macao Beach with its sweeping curves and gentle surf. Snorkel around Catalina Island's vibrant reefs for dazzling marine color.",
      },
      {
        question: 'Where can you dock your yacht charter in Punta Cana?',
        answer:
          'The Marina Cap Cana is your premier docking location, set within an elite resort enclave. Berths here lead to gourmet dining, upscale shops, golf courses, and spa escapes. Docked or dockside, the service here radiates warm professionalism.',
      },
      {
        question: 'What is the best season to sail in Punta Cana?',
        answer:
          "December to April offers calm seas, consistent breeze, and low humidity—perfect for sailing and exploring. It's the season when the sun feels just right, and every horizon glows. It's your chance to shine under perfect Caribbean skies.",
      },
    ],
  },
  {
    id: 'fajardo-puerto-rico',
    imgSrc: 'images/rentals/fajardo-puerto-rico-2.jpg',
    pageTitle: 'Fajardo Boat Rentals & Charters',
    h1: 'Rent a boat in Fajardo, Puerto Rico',
    queryParams: {
      latitudeSw: 18.30619595325557,
      longitudeSw: -65.68592006961246,
      latitudeNe: 18.36030199047645,
      longitudeNe: -65.62460399102928,
      near: 'Fajardo, Puerto Rico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Puerto Rico',
    faq: [
      {
        question: 'What are the best destinations during your Fajardo boat charter?',
        answer:
          'Navigate through the Spanish Virgin Islands and experience remote cays such as Icacos and Culebrita for dreamy beaches. Anchor in the sheltered Laguna Grande for bioluminescent water that lights up your nightly cruise. Then, dive into vibrant coral reefs teeming with marine life.',
      },
      {
        question: 'Where can you dock your yacht charter in Fajardo?',
        answer:
          "Fajardo's Marina Puerto del Rey is one of the largest in the Caribbean and offers secure berths and services. A quick ride will get you back into Fajardo town for fresh seafood and island charm. With full-service staff and top-tier facilities, your boating comfort comes first.",
      },
      {
        question: 'What is the best season to sail in Fajardo?',
        answer:
          "December through April is your golden window—clear skies, calm seas, and gentle trade winds define the perfect sailing season. It's an invitation to explore each bay and cove at ease. Sail this time, and every night under the stars will feel magical.",
      },
    ],
  },
  {
    id: 'puerto-aventura-mexico',
    imgSrc: 'images/rentals/puerto-aventura-mexico-2.jpg',
    pageTitle: 'Puerto Aventuras Boat Rentals & Charters',
    h1: 'Rent a boat in Puerto Aventuras, Mexico',
    queryParams: {
      latitudeSw: 20.49226391961519,
      longitudeSw: -87.23982810979655,
      latitudeNe: 20.52235672273934,
      longitudeNe: -87.21540647549277,
      near: '77733 Puerto Aventuras, Quintana Roo, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Puerto Aventuras',
    faq: [
      {
        question: 'What are the best destinations during your Puerto Aventuras boat charter?',
        answer:
          "Cruise down the Riviera Maya coast to Cozumel's vibrant reefs or drift south toward secluded cenotes accessible only by boat. Glide into Yal-ku Lagoon for kayaking and swimming in serene emerald waters. Don't miss out on snorkeling at Chinchorro Banks, a haven of marine biodiversity.",
      },
      {
        question: 'Where can you dock your yacht charter in Puerto Aventuras?',
        answer:
          "The Marina Puerto Aventuras is your gateway to Caribbean bliss—prepped with modern slips, service desks, and restaurants steps away. Within walking distance, you'll discover shops, bars and golf vibes. The staff here make each docking smooth and warm.",
      },
      {
        question: 'What is the best season to sail in Puerto Aventuras?',
        answer:
          "November to April brings steady sailing conditions, bright sunshine, and calm sapphire seas. It's the perfect recipe for day-long adventures and sunset sails. This season invites you to wear sun-kissed smiles and dive into island rhythm.",
      },
    ],
  },
  {
    id: 'saint-lucia',
    imgSrc: 'images/rentals/saint-lucia-2.jpg',
    pageTitle: 'Saint Lucia Boat Rentals & Charters',
    h1: 'Rent a boat in Saint Lucia',
    queryParams: {
      latitudeSw: 13.4707779414,
      longitudeSw: -61.3160091099,
      latitudeNe: 14.3549276688,
      longitudeNe: -60.6257946105,
      near: 'St Lucia',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Saint Lucia',
    faq: [
      {
        question: 'What are the best destinations during your Saint Lucia boat charter?',
        answer:
          "Behold the majestic Pitons rising from the sea, best appreciated from your yacht deck. Cruise to Marigot Bay, a tranquil sunset haven framed by lush hills. Adventure seekers will love snorkeling and diving at Anse Chastanet's dramatic reefs.",
      },
      {
        question: 'Where can you dock your yacht charter in Saint Lucia?',
        answer:
          "Rodney Bay Marina offers world-class docking and abundant resort facilities. Close by, the marina touches vibrant nightlife, shops, and beachfront restaurants. Dock here and you're instantly immersed in Caribbean elegance.",
      },
      {
        question: 'What is the best season to sail in Saint Lucia?',
        answer:
          "December to April is the crown jewel of sailing season: sunny days, refreshingly cool trade winds, and calm seas. Every sail feels smoother and every vista more vibrant. It's the best time to engage with both the ocean and the island's vibrant spirit.",
      },
    ],
  },
  {
    id: 'antigua-and-barbuda',
    imgSrc: 'images/rentals/antigua-and-barbuda-2.jpg',
    pageTitle: 'Antigua and Barbuda Boat Rentals & Charters',
    h1: 'Rent a boat in Antigua and Barbuda',
    queryParams: {
      latitudeSw: 16.9308125654,
      longitudeSw: -62.3944822117,
      latitudeNe: 17.8866279351,
      longitudeNe: -61.4603553006,
      near: 'Antigua and Barbuda',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Antigua and Barbuda',
    faq: [
      {
        question: 'What are the best destinations during your Antigua and Barbuda boat charter?',
        answer:
          "Ride the tide toward the scenic English Harbour—home to Nelson's Dockyard and picture-perfect harbors. Sail around Barbuda for secluded pink-sand beaches and coastal flamingo sightings. Navy or Shirley Heights looks at sunset makes every moment unforgettable.",
      },
      {
        question: 'Where can you dock your yacht charter in Antigua and Barbuda?',
        answer:
          "Nelson's Dockyard Marina in English Harbour is a historical and practical docking destination, with full services and a charming village feel. Falmouth Harbour and Jolly Harbour are equally well-appointed with lively after-hours scenes. Each marina offers friendly crews and excellent infrastructure.",
      },
      {
        question: 'What is the best season to sail in Antigua and Barbuda?',
        answer:
          'December to April is ideal: reliable easterly trade winds, sunlit skies, and smooth ocean swells. Every day on the water feels like paradise—warm, breezy, and supremely memorable. This season elevates every aspect of your charter experience.',
      },
    ],
  },
  {
    id: 'barbados',
    imgSrc: 'images/rentals/barbados-2.jpg',
    pageTitle: 'Barbados Boat Rentals & Charters',
    h1: 'Rent a boat in Barbados',
    queryParams: {
      latitudeSw: 13.0004970247,
      longitudeSw: -59.6742386826,
      latitudeNe: 13.3275393188,
      longitudeNe: -59.4202933314,
      near: 'Barbados',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Barbados',
    faq: [
      {
        question: 'What are the best destinations during your Barbados boat charter?',
        answer:
          "Sail downwind to Carlisle Bay, where calm water and marine wildlife—like turtles—thrive in the bay's gentle embrace. Cruise the rugged Atlantic coast for dramatic cliffs and coastal panoramas, then drift back to the calm west coast for swimmable shores and beachside rum shops.",
      },
      {
        question: 'Where can you dock your yacht charter in Barbados?',
        answer:
          "Port St. Charles Marina and Bridgetown Port accommodate everything from boutique yachts to larger vessels—offering high-end amenities and ease of access to island highlights. Both locations provide top-tier assistance and luxury onshore options. Dock here and you'll be steps from fine dining and vibrant culture.",
      },
      {
        question: 'What is the best season to sail in Barbados?',
        answer:
          "December through April is sailing perfection: steady breezes, warm air, and sea comfort. It's the sweet spot for discovery, indulgence, and ocean views. Each day is full of radiance—just like Barbados itself.",
      },
    ],
  },
  {
    id: 'british-virgin-islands',
    imgSrc: 'images/rentals/british-virgin-islands-2.jpg',
    pageTitle: 'British Virgin Islands Boat Rentals & Charters',
    h1: 'Rent a boat in British Virgin Islands',
    queryParams: {
      latitudeSw: 17.9766868,
      longitudeSw: -65.1905265,
      latitudeNe: 19.1256392,
      longitudeNe: -63.8867465,
      near: 'British Virgin Islands',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'British Virgin Islands',
    faq: [
      {
        question: 'What are the best destinations during your British Virgin Islands boat charter?',
        answer:
          "Explore the Baths at Virgin Gorda — a labyrinth of giant boulders and secret pools. Sail to Norman Island, where Pirate's Bight and The Indians offer legendary snorkeling in blue water grottos. Add a stop at Anegada for coral reefs and flamingo-filled inlets—it feels like a private world.",
      },
      {
        question: 'Where can you dock your yacht charter in the BVI?',
        answer:
          "Road Town in Tortola and Marina Cay offer well-equipped harbors with top services. Beyond those, Soper's Hole and The Bight are dotted with tidal moorings and welcome charter-friendly vibes. Each anchorage blends convenience with laid-back British-Caribbean charm.",
      },
      {
        question: 'What is the best season to sail in the BVI?',
        answer:
          "December through April offers mild winds, warm weather, and perfected crystal seas. It's the high season of yachting bliss, with steady trades and happy anchorages. Set sail then, and every sail feels smooth and soulful.",
      },
    ],
  },
  {
    id: 'mykonos-greece',
    imgSrc: 'images/rentals/mykonos-greece-2.jpg',
    pageTitle: 'Mykonos Boat Rentals & Charters',
    h1: 'Rent a boat in Mykonos, Greece',
    queryParams: {
      latitudeSw: 37.3526939137,
      longitudeSw: 25.2465303653,
      latitudeNe: 37.5364286864,
      longitudeNe: 25.4246367473,
      near: 'Mykonos 846 00, Greece',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Mykonos',
    faq: [
      {
        question: 'What are the best destinations during your Mykonos boat charter?',
        answer:
          "Glide out to Delos Island, a legendary archaeological sanctuary with white marble ruins and dreamy mythology. Mykonos's beaches—like Kalo Livadi and Super Paradise—blend music, cocktails, and brilliant sand. Let the sunset hues paint the sky as you anchor in Agios Stefanos, just off the town's bright-tradition skyline.",
      },
      {
        question: 'Where can you dock your yacht charter in Mykonos?',
        answer:
          'Go directly into Mykonos Old or New Port, both offering full-service berths and whisking you into chic tavernas and buzzing nightlife within minutes. Alternatively, anchor at Ornos or Psarou Bay for a more secluded, beach-club vibe. Each port delivers upscale comfort and warm Aegean touches.',
      },
      {
        question: 'What is the best season to sail in Mykonos?',
        answer:
          "From late May through September, with peak mediterranean sun and summer's Meltemi winds in full flow. Days stretch longer, nights stay balmy, and the social scene hums—there really isn't a better time to experience the Cyclades. Sail when the island is alive, and every moment feels epic.",
      },
    ],
  },
  {
    id: 'amalfi-italy',
    imgSrc: 'images/rentals/amalfi-italy-2.jpg',
    pageTitle: 'Amalfi Boat Rentals & Charters',
    h1: 'Rent a boat in Amalfi, Italy',
    short: 'Amalfi',
    queryParams: {
      latitudeSw: 40.4622664863,
      longitudeSw: 14.4194349829,
      latitudeNe: 40.7997113065,
      longitudeNe: 14.763900515,
      near: '84011 Amalfi, SA, Italy',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    faq: [
      {
        question: 'What are the best destinations during your Amalfi Coast boat charter?',
        answer:
          "Coasting past Positano's pastel cliffs is a feast for the eyes, with luxury hotels draped along the hills. Stop in Amalfi for historic cathedrals and intimate piazzas. Then drift toward hidden gems like Furore's fjord or the dramatic Ravello cliffs—each moment feels like a scene from a postcard.",
      },
      {
        question: 'Where can you dock your yacht charter in Amalfi?',
        answer:
          "Amalfi Marina and Positano Harbour (via mooring buoys or small docks) offer ideal berthing surrounded by Italian elegance. Each port gives you direct access to charming cobblestone streets, artisan shops, and seaside cafes. From dock to dine, you'll be living la dolce vita.",
      },
      {
        question: 'What is the best season to sail on the Amalfi Coast?',
        answer:
          "May through September brings perfect clarity in weather, warm Mediterranean seas, and just the right humidity for sunset sails. June and September are particularly magical—they're lively but without the midsummer crowds. This is when the coast glows with authenticity, and every vista feels timeless.",
      },
    ],
  },
];

export interface FAQItem {
  question: string;
  answer: string;
}

export interface BoatRental {
  id: string;
  imgSrc: string;
  pageTitle: string;
  h1: string;
  short: string;
  queryParams: {
    latitudeSw: number;
    longitudeSw: number;
    latitudeNe: number;
    longitudeNe: number;
    near: string;
  };
  metaDescription: string;
  faq?: FAQItem[];
}

export interface BoatRentalTransformed {
  lat: number;
  lng: number;
  sw_lat: number;
  sw_lng: number;
  ne_lat: number;
  ne_lng: number;
  lat_lng_sw: string;
  lat_lng_ne: string;
  near: string;
  source: string;
  action: string;
}

const transformBoatRental = (input: BoatRental): BoatRentalTransformed => {
  return {
    lat: (input.queryParams.latitudeSw + input.queryParams.latitudeNe) / 2,
    lng: (input.queryParams.longitudeSw + input.queryParams.longitudeNe) / 2,
    sw_lat: input.queryParams.latitudeSw,
    sw_lng: input.queryParams.longitudeSw,
    ne_lat: input.queryParams.latitudeNe,
    ne_lng: input.queryParams.longitudeNe,
    lat_lng_sw: `${input.queryParams.latitudeSw},${input.queryParams.longitudeSw}`,
    lat_lng_ne: `${input.queryParams.latitudeNe},${input.queryParams.longitudeNe}`,
    near: input.queryParams.near,
    source: 'search',
    action: 'search',
  };
};

export { boatRentals, transformBoatRental };
